import { BrowserModule } from '@angular/platform-browser';
import { NgModule, LOCALE_ID } from '@angular/core';
import { AppComponent } from './app.component';
import { NavbarComponent } from './navbar/navbar.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { FooterComponent } from './footer/footer.component';
import { AppRoutingModule } from './/app-routing.module';
import { DashboardComponent } from './dashboard/dashboard.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BingoComponent } from './bingo/bingo.component';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { LoginComponent } from './login/login.component';
import { Ng2FlatpickrModule } from 'ng2-flatpickr';
import { InformesComponent } from './informes/informes.component';
import { DataTablesModule } from 'angular-datatables';
import { BtComponent } from './bt/bt.component';
import { B3Component } from './b3/b3.component';
import { CmComponent } from './cm/cm.component';
import { BetComponent } from './bet/bet.component';
import { TotalComponent } from './total/total.component';
import { HosteleriaComponent } from './hosteleria/hosteleria.component';
import { MapaComponent } from './mapa/mapa.component';
import { AgmCoreModule } from '@agm/core';
import { TableComponent } from './table/table.component';
import { ErrorsComponent } from './errors/errors.component';
import { AlertasComponent } from './alertas/alertas.component';
import { VariablesComponent } from './variables/variables.component';
import { HistorialComponent } from './historial/historial.component';
import { GraficasConjuntasComponent } from './graficas-conjuntas/graficas-conjuntas.component';
import { GraficasComponent } from './graficas/graficas.component';
import { EverisListadoComponent } from './everis-listado/everis-listado.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { HomeComponent } from './home/home.component';
import { DireccionComponent } from './direccion/direccion.component';
import { EstadisticasEverisComponent } from './estadisticas-everis/estadisticas-everis.component';
import { DireccionUniqueComponent } from './direccion-unique/direccion-unique.component';
import { ParkingComponent } from './parking/parking.component';
import { PagosparkingComponent } from './pagosparking/pagosparking.component';
import { ArqueappComponent } from './arqueapp/arqueapp.component';
import { FactComponent } from './fact/fact.component';
import { OcupacionComponent } from './ocupacion/ocupacion.component';
import { ConcurrenciaComponent } from './concurrencia/concurrencia.component';
import { CuadranteComponent } from './cuadrante/cuadrante.component';
import { ReservasParkingComponent } from './reservas-parking/reservas-parking.component';
import { CalllogComponent } from './calllog/calllog.component';
import { FactDifComponent } from './fact-dif/fact-dif.component';
import { HerramientasComponent } from './herramientas/herramientas.component';
import { DocumentationComponent } from './documentation/documentation.component';
import { PresencialComponent } from './presencial/presencial.component';
import { NotificacionesComponent } from './notificaciones/notificaciones.component';
import { AngularMyDatePickerModule } from 'angular-mydatepicker';
import { SlaveComponent } from './slave/slave.component';
import { ProduccionComponent } from './produccion/produccion.component';
import { IncidenciasComponent } from './incidencias/incidencias.component';
import { BingoeComponent } from './bingoe/bingoe.component';
import { RangoshoraComponent } from './rangoshora/rangoshora.component';
import { VentasComponent } from './ventas/ventas.component';
import localeES from '@angular/common/locales/es';
import { registerLocaleData } from '@angular/common';
import { CuadranteParkingComponent } from './cuadrante-parking/cuadrante-parking.component';
import { AcuerdosComponent } from './acuerdos/acuerdos.component';
import { CrearAcuerdoComponent } from './crear-acuerdo/crear-acuerdo.component';
import { EditarAcuerdoComponent } from './editar-acuerdo/editar-acuerdo.component';
import { CrearValorComponent } from './crear-valor/crear-valor.component';
import { FactbalisaComponent } from './factbalisa/factbalisa.component';
import { FactplazaComponent } from './factplaza/factplaza.component';
import { ZktecoComponent } from './zkteco/zkteco.component';
import Swal from 'sweetalert2';
import { ZkregistrosComponent } from './zkregistros/zkregistros.component';
import { ConsultarAcuerdosComponent } from './consultar-acuerdos/consultar-acuerdos.component';
registerLocaleData(localeES);

@NgModule({
  declarations: [    
    AppComponent,
    NavbarComponent,
    SidebarComponent,
    FooterComponent,
    DashboardComponent,
    BingoComponent,
    LoginComponent,
    InformesComponent,
    BtComponent,
    B3Component,
    CmComponent,
    BetComponent,
    TotalComponent,
    HosteleriaComponent,
    MapaComponent,
    TableComponent,
    ErrorsComponent,
    AlertasComponent,
    VariablesComponent,
    HistorialComponent,
    GraficasConjuntasComponent,
    GraficasComponent,
    EverisListadoComponent,
    HomeComponent,
    DireccionComponent,
    EstadisticasEverisComponent,
    DireccionUniqueComponent,
    ParkingComponent,
    PagosparkingComponent,
    ArqueappComponent,
    FactComponent,
    OcupacionComponent,
    ConcurrenciaComponent,
    CuadranteComponent,
    ReservasParkingComponent,
    CalllogComponent,
    FactDifComponent,
    HerramientasComponent,
    DocumentationComponent,
    PresencialComponent,
    NotificacionesComponent,
    SlaveComponent,
    ProduccionComponent,
    IncidenciasComponent,
    BingoeComponent,
    RangoshoraComponent,
    VentasComponent,
    CuadranteParkingComponent,
    AcuerdosComponent,
    CrearAcuerdoComponent,
    EditarAcuerdoComponent,
    CrearValorComponent,
    FactbalisaComponent,
    FactplazaComponent,
    ZktecoComponent,
    ZkregistrosComponent,
    ConsultarAcuerdosComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    DataTablesModule,
    Ng2FlatpickrModule,
    NgSelectModule,
    FormsModule,
    AngularMyDatePickerModule,
    AgmCoreModule.forRoot({
      apiKey: ''
     }),
    HttpClientModule
    // NotificationsModule,
  ],
  providers: [
    { provide: LOCALE_ID, useValue: 'es-ESP' },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
